"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.create.title': 'Crea Tutorial',
    'tutorial.create.button': 'Crea Tutorial',
};
